import { render, staticRenderFns } from "./HoursAccessConfig.vue?vue&type=template&id=e45e5a14&scoped=true"
import script from "./HoursAccessConfig.vue?vue&type=script&lang=js"
export * from "./HoursAccessConfig.vue?vue&type=script&lang=js"
import style0 from "./HoursAccessConfig.vue?vue&type=style&index=0&id=e45e5a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45e5a14",
  null
  
)

export default component.exports